import { EXPERIMENTS, createFormView, useExperiments, useConfig } from '@wix/form-fields';
import { useMemo } from 'react';
export const useFormView = (form, stepId, breakpoint)=>{
    const { isMobile } = useConfig();
    const experiments = useExperiments();
    const useFieldsV2App = experiments.isExperimentEnabled(EXPERIMENTS.USE_FIELDS_V2);
    const useFieldsV2Standalone = experiments.isExperimentEnabled(EXPERIMENTS.USE_FIELDS_V2_STANDALONE);
    const useFieldsV2PP = experiments.isExperimentEnabled(EXPERIMENTS.USE_FIELDS_V2_PP);
    const useFormSchemaV2PricingPlans = experiments.isExperimentEnabled(EXPERIMENTS.ENABLE_FORM_SCHEMA_V2_PRICING_PLANS);
    const useFieldsV2 = useFieldsV2App || useFieldsV2Standalone || useFieldsV2PP || useFormSchemaV2PricingPlans;
    return useMemo(()=>{
        return (form?.steps || []).filter((step)=>!stepId || stepId === step.id).map((step)=>{
            return createFormView({
                form,
                stepId: step.id,
                isMobile,
                breakpoint,
                useFieldsV2
            });
        });
    }, [
        form,
        stepId,
        isMobile,
        breakpoint,
        useFieldsV2
    ]);
};

//# sourceMappingURL=use-form-view.js.map